import {
  LendCollection,
  LendCollectionFromJSON,
  ReserveCollection,
  ReserveCollectionFromJSON,
  UserBase,
  UserBaseFromJSON,
  UserPersonal,
  UserPersonalFromJSON,
  UserMemo,
  UserMemoFromJSON,
  UserNote,
  UserNoteFromJSON,
  NowStatus,
  NowStatusFromJSON
} from '@/api'

export interface UserFamily {
  base: UserBase
  personal: UserPersonal
  memos: UserMemo[]
  notes: UserNote[]
  nowStatus: NowStatus
  lendCollections: LendCollection[]
  reserveCollections: ReserveCollection[]
}

export function UserFamilyFromJSON(json: any): UserFamily {
  return {
    base: UserBaseFromJSON(json.base),
    personal: UserPersonalFromJSON(json.personal),
    memos: json.memos.map(UserMemoFromJSON),
    notes: json.notes.map(UserNoteFromJSON),
    nowStatus: NowStatusFromJSON(json.now_status),
    lendCollections: (json.lend_collections as any[]).map(
      LendCollectionFromJSON
    ),
    reserveCollections: json.reserve_collections.map(ReserveCollectionFromJSON)
  }
}
